import { KeyOption, matchSorter } from 'match-sorter'

export function markText(
  text: string,
  searchValue: string,
  notMatchReturn?: string
) {
  try {
    const strArr = text.split(new RegExp(`(${searchValue})`, 'ig'))
    return strArr.map((ea, i) => {
      if (ea.toLowerCase() === searchValue.toLowerCase()) {
        return (
          <mark key={`match${i}`} className="Search-suggestions-match">
            {ea}
          </mark>
        )
      } else {
        return notMatchReturn === undefined ? ea : notMatchReturn
      }
    })
  } catch {
    return notMatchReturn === undefined ? text : notMatchReturn
  }
}

const ignoreChars = ['.', '-', '_', ',']
export function markTextSplitBySpaces(text: string, searchValue: string) {
  try {
    const terms = searchValue
      .split(' ')
      .map((x) => x.trim())
      .filter((x) => x?.length > 1 && !ignoreChars.includes(x)) // remove empty terms

    let htmlText = text

    // console.log(terms)

    terms.forEach((term) => {
      const reg = new RegExp(`(${term})`, 'ig')
      const match = htmlText.match(reg)
      if (match) {
        match.forEach((m) => {
          // const reg = new RegExp(`(${m})`, 'ig')
          const reg = new RegExp(`${m}`, 'ig')
          // console.log(htmlText)
          htmlText = htmlText.replace(reg, `<mark>${m}</mark>`)
        })
      }
    })

    return htmlText
  } catch {
    return text
  }
}

export function fuzzySearchMultipleWords<T>(
  rows: Array<T>, // array of data [{a: "a", b: "b"}, {a: "c", b: "d"}]
  keys: KeyOption<T>[], // keys to search ["a", "b"]
  filterValue: string // potentially multi-word search string "two words"
) {
  if (!filterValue || !filterValue.length) {
    return rows
  }

  const terms = filterValue.split(' ')
  if (!terms) {
    return rows
  }

  // reduceRight will mean sorting is done by score for the _first_ entered word.
  return terms.reduceRight(
    (results, term) =>
      matchSorter(results, term, {
        keys: keys,
      }),
    rows
  )
}
